import type { CanEntitlement, EntitlementChecker } from '#layers/access/composables/use-entitlement';
import { useAuth } from '#layers/access/stores/auth';

/** A bound organization entitlement check — the `can` of `useOrganizationEntitlement()`. */
export type OrganizationEntitlementChecker = EntitlementChecker;

/**
 * Direct organization entitlement gate.
 *
 * The Engine currently grants every organization entitlement to organization admins and denies
 * every one to other members. Keep the entitlement argument in this frontend seam so callers can
 * name the capability they depend on and the implementation can adopt granular grants later
 * without changing every consumer.
 */
export function useOrganizationEntitlement() {
	const auth = useAuth();

	function can(_entitlement: CanEntitlement): boolean {
		return auth.isOrganizationAdmin;
	}

	return { can };
}
